import {UNAUTHORIZED} from "../../reducers/indexReducer";

export const unauthorizedError = () =>{

    return {
        type: UNAUTHORIZED
    }
}